import { useEffect } from 'react'

export const useTabTitle = (state, titleGenerator) => {
    useEffect(() => {
        const newTitle = titleGenerator(state)
        document.title = newTitle
    }, [state, titleGenerator])
}
export const setTabTitle = (title) => {
    document.title = title
}
